class DocumentationPathWizard {

    constructor() {

        this._returnToPathWizardPreview = null;
        this._pathWizardData = new DocumentationPathWizardData();

    }

    enableHandlers() {
        $("div.action-button.is-path-wizard.has-course").on("click.wizardCourseButton", this._onClickWizardCourseButton.bind(this));
    }

    enablePreviewHandlers() {

        $("div.action-button.is-path-wizard.access-document").on("click.accessDocument", this._onClickWizardAccessDocument.bind(this));
        $("div.path-dashboard-wizard-nav > div.previous-content-button.is-enabled").on("click.previousWizardPreviewContent", this._onClickPreviousWizardPreviewContent.bind(this));
        $("div.path-dashboard-wizard-nav > div.next-content-button.is-enabled").on("click.nextWizardPreviewContent", this._onClickNextWizardPreviewContent.bind(this));
        $("div.path-dashboard-wizard-nav > div.return-content-button.is-enabled").on("click.returnWizardPreviewContent", this._onClickReturnWizardPreviewContent.bind(this));
        $("div.content-locked-button").on("click.showBlockedPopUp", documentationScreenController.documentationPath.openBlockedContentPopUp.bind(documentationScreenController.documentationPath));

    }

    getReturnToPathWizardPreview() {
        return this._returnToPathWizardPreview;
    }

    setReturnToPathWizardPreview(index) {
        this._returnToPathWizardPreview = index;
    }

    setWizardCarousel(startIndex = 0) {

        function _startsCarouselFromPosition() {

            const $opacityScreen = $("div.doc-details-PATH.is-path-wizard > div.opacity-screen");
            const $pathSelectorsToHide = $("div.path-info, div.path-action-buttons-container, #documentation-full-screen-header");
            const pathData = documentationScreenController.documentationPath.getPathData();
            const totalContents = pathData.numberOfContents;

            $opacityScreen.addClass("is-visible");
            $pathSelectorsToHide.addClass("is-hidden");

            if (startIndex === totalContents) {
                $nextButton.removeClass("is-enabled");
                $returnButton.addClass("is-enabled");
            } else {
                $returnButton.removeClass("is-enabled");
            }

        }

        function _startsCarouselFromBeginning() {

            $carouselWizard.addClass("is-hidden");
            $prevButton.removeClass("is-enabled");
            $returnButton.removeClass("is-enabled");

        }

        const pathUtils = documentationScreenController.documentationPath.getPathUtils();
        const dotsContString = "#dots-carousel-path-wizard";
        const $dotsContainer = $(dotsContString);
        const $closeDetailsButton = $("#documentation-header-close-btn");
        const $carouselWizard = $("div.owl-carousel-path-wizard");
        const $nextButton = $("div.next-content-button");
        const $prevButton = $("div.previous-content-button");
        const $returnButton = $("div.return-content-button");
        const $window = $(window);

        $carouselWizard.owlCarousel({
            items: 1,
            center: true,
            dots: true,
            dotsContainer: dotsContString,
            startPosition: startIndex
        });

        const $dotsCarousel = $("#dots-carousel-path-wizard span");

        if (startIndex > 0) {
            _startsCarouselFromPosition();
        } else {
            _startsCarouselFromBeginning();
        }

        $dotsCarousel.addClass("dot-carousel");
        $dotsContainer.find(".owl-dot.active > .dot-carousel").addClass("world_color_1_bg");

        pathUtils.setPathWizardItemPreviewEllipsis();
        pathUtils.setPathWizardItemPreviewStyles();

        $window.on("resize.resizeCards", function() {
            pathUtils.setPathWizardItemPreviewEllipsis();
            pathUtils.setPathWizardItemPreviewStyles();
        });

        $closeDetailsButton.on("click.removeResizeListener", function() {
            $window.off("resize.resizeCards");
        })

        $carouselWizard.on("changed.owl.carousel", function(event) {

            const index = event.item.index;
            const total = event.item.count;

            if (index === 0) {

                const $pathSelectorsToShow = $("div.path-info, div.path-action-buttons-container, #documentation-full-screen-header");
                const $opacityScreen = $("div.doc-details-PATH.is-path-wizard > div.opacity-screen");

                setTimeout(function() {
                    $carouselWizard.addClass("is-hidden");
                    $opacityScreen.removeClass("is-visible");
                    $pathSelectorsToShow.removeClass("is-hidden");
                }, 100);

                $prevButton.removeClass("is-enabled");
                $returnButton.removeClass("is-enabled");
                $nextButton.addClass("is-enabled");

            } else if (index + 1 === total) {
                $nextButton.removeClass("is-enabled");
                $returnButton.addClass("is-enabled");
            } else {
                $prevButton.addClass("is-enabled");
                $nextButton.addClass("is-enabled");
                $returnButton.removeClass("is-enabled");
            }

            $dotsContainer.find(".dot-carousel").removeClass("world_color_1_bg");
            $dotsContainer.find(".owl-dot.active > .dot-carousel").addClass("world_color_1_bg");

        });

    }

    _onClickWizardCourseButton(event) {

        function _onChangeDocumentDetails() {

            const $closeDetailsButton = $("#documentation-header-close-btn");
            $closeDetailsButton.trigger("click");

        }

        const $this = $(event.currentTarget);
        const pathData = documentationScreenController.documentationPath.getPathData();
        const pathUtils = documentationScreenController.documentationPath.getPathUtils();

        let nextClass = null;

        if ($this.hasClass("is-not-started") || $this.hasClass("is-completed")) {
            nextClass = pathUtils.getFirstClass(pathData);
        }

        if ($this.hasClass("is-in-process")) {
            nextClass = pathData.nextDocumentToComplete;
        }

        const documentId = nextClass.id;
        const document = documentationScreenController.getDocument(documentId);
        const parentFolder = documentationScreenController.getParentFolder(documentId, documentationScreenController.documentation);
        const currentIndex = pathUtils.getPathWizardItemPosition(pathData, documentId);
        const isBlocked = pathData.sections[0].items[currentIndex].isBlocked;
        const nextIsBlocked = currentIndex + 1 < pathData.sections[0].items.length ? pathData.sections[0].items[currentIndex + 1].isBlocked : false;

        this._pathWizardData.setNavigationData(pathData, currentIndex, isBlocked, nextIsBlocked);

        document.isPathWizardPreviewContent = true;
        document.pathWizardPreviewNavData = this._pathWizardData.getNavigationData();

        _onChangeDocumentDetails();

        documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);

    }

    _onClickWizardAccessDocument(event) {

        function _onChangeDocumentDetails() {

            const $closeDetailsButton = $("#documentation-header-close-btn");
            $closeDetailsButton.trigger("click");

            that.setReturnToPathWizardPreview(previewIndex);

        }

        const $this = $(event.currentTarget);
        const that = this;
        const documentId = $this.data("id");
        const previewIndex = $this.data("index");
        const document = documentationScreenController.getDocument(documentId);
        const parentFolder = documentationScreenController.getParentFolder(documentId, documentationScreenController.documentation);

        _onChangeDocumentDetails();

        documentationScreenController.drawDocumentDetails(null, document, null, parentFolder);

    }

    _onClickNextWizardPreviewContent(event) {

        const $carouselPathWizard = $("div.owl-carousel-path-wizard");
        const $opacityScreen = $("div.doc-details-PATH.is-path-wizard > div.opacity-screen");
        const $pathSelectorsToHide = $("div.path-info, div.path-action-buttons-container, #documentation-full-screen-header");

        $carouselPathWizard.removeClass("is-hidden");
        $opacityScreen.addClass("is-visible");
        $pathSelectorsToHide.addClass("is-hidden");
        $carouselPathWizard.trigger("next.owl.carousel");

    }

    _onClickPreviousWizardPreviewContent(event) {

        const $carouselPathWizard = $("div.owl-carousel-path-wizard");
        $carouselPathWizard.trigger("prev.owl.carousel");

    }

    _onClickReturnWizardPreviewContent(event) {

        const $carouselPathWizard = $("div.owl-carousel-path-wizard");
        $carouselPathWizard.trigger("to.owl.carousel", [0, 0]);


    }

}